import { EnvelopeFlowState } from "@app/const/consts";
import { FiltersName, mockTransFunc } from "@const/translations";
import {
  FilterCondition,
  FilterRules,
  ILibFilters,
  ILibOption,
} from "@infologistics/frontend-libraries";
import { flowStateSettings } from "../../consts";
import {
  FILTER_DATE_TIME_OPTIONS,
  FILTER_DATE_RULES,
} from "@app/const/filters";

enum FILTERS_NAMES {
  senderFullName = "sender_fullName",
  senderEmail = "sender_email",
  recipientFullName = "recipient_fullName",
  recipientEmail = "recipient_email",
  subject = "subject",
  flowState = "flowState",
  flowStarted = "flowStarted",
  flowCompleted = "flowCompleted",
  flowLastActionDate = "flowLastActionDate",
}

const ENVELOPES_FILTERS_ORDER = [
  FILTERS_NAMES.senderFullName,
  FILTERS_NAMES.senderEmail,
  FILTERS_NAMES.recipientFullName,
  FILTERS_NAMES.recipientEmail,
  FILTERS_NAMES.subject,
  FILTERS_NAMES.flowState,
  FILTERS_NAMES.flowStarted,
  FILTERS_NAMES.flowCompleted,
  FILTERS_NAMES.flowLastActionDate,
];

export const ENVELOPES_FILTERS_DATES = [
  "flowStarted",
  "flowCompleted",
  "flowLastActionDate",
];

const FLOW_STATE_VALUES: ILibOption[] = Object.keys(EnvelopeFlowState).map(
  (val) => ({
    label: mockTransFunc(flowStateSettings[val].title),
    value: val,
  })
);

const envelopesFiltersData: ILibFilters = {
  [FILTERS_NAMES.senderFullName]: {
    condition: FilterCondition.ALL,
    name: FILTERS_NAMES.senderFullName,
    rules: {
      [FilterCondition.ALL]: FilterRules.ALL,
      [FilterCondition.CONTAINS]: FilterRules.TEXT,
    },
    translation: FiltersName.senderName,
  },
  [FILTERS_NAMES.senderEmail]: {
    condition: FilterCondition.ALL,
    name: FILTERS_NAMES.senderEmail,
    rules: {
      [FilterCondition.ALL]: FilterRules.ALL,
      [FilterCondition.CONTAINS]: FilterRules.TEXT,
    },
    translation: FiltersName.senderEmail,
  },
  [FILTERS_NAMES.recipientFullName]: {
    condition: FilterCondition.ALL,
    name: FILTERS_NAMES.recipientFullName,
    rules: {
      [FilterCondition.ALL]: FilterRules.ALL,
      [FilterCondition.CONTAINS]: FilterRules.TEXT,
    },
    translation: FiltersName.recipientName,
  },
  [FILTERS_NAMES.recipientEmail]: {
    condition: FilterCondition.ALL,
    name: FILTERS_NAMES.recipientEmail,
    rules: {
      [FilterCondition.ALL]: FilterRules.ALL,
      [FilterCondition.CONTAINS]: FilterRules.TEXT,
    },
    translation: FiltersName.recipientEmail,
  },
  [FILTERS_NAMES.subject]: {
    condition: FilterCondition.ALL,
    name: FILTERS_NAMES.subject,
    rules: {
      [FilterCondition.ALL]: FilterRules.ALL,
      [FilterCondition.CONTAINS]: FilterRules.TEXT,
    },
    translation: FiltersName.subject,
  },
  [FILTERS_NAMES.flowState]: {
    condition: FilterCondition.ALL,
    name: FILTERS_NAMES.flowState,
    options: FLOW_STATE_VALUES,
    rules: {
      [FilterCondition.ALL]: FilterRules.ALL,
      [FilterCondition.EQ]: FilterRules.SELECT,
    },
    translation: FiltersName.flowState,
  },
  [FILTERS_NAMES.flowStarted]: {
    condition: FilterCondition.ALL,
    name: FILTERS_NAMES.flowStarted,
    options: FILTER_DATE_TIME_OPTIONS,
    rules: FILTER_DATE_RULES,
    translation: FiltersName.flowStarted,
  },
  [FILTERS_NAMES.flowCompleted]: {
    condition: FilterCondition.ALL,
    name: FILTERS_NAMES.flowCompleted,
    options: FILTER_DATE_TIME_OPTIONS,
    rules: FILTER_DATE_RULES,
    translation: FiltersName.flowCompleted,
  },
  [FILTERS_NAMES.flowLastActionDate]: {
    condition: FilterCondition.ALL,
    name: FILTERS_NAMES.flowLastActionDate,
    options: FILTER_DATE_TIME_OPTIONS,
    rules: FILTER_DATE_RULES,
    translation: FiltersName.flowLastActionDate,
  },
};

export const envelopesFilters = {
  data: envelopesFiltersData,
  order: ENVELOPES_FILTERS_ORDER,
};
